import classNames from 'classnames/bind';
import styles from './PathSelectionReadMore.module.scss';
import Card, { CardHeader } from '../../../../components/Card';
import Button from '../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import Footer from '../../../../components/Footer';

const cx = classNames.bind(styles);

const PathSelectionReadMore = () => {
  const navigate = useNavigate();

  const onGoBack = () => navigate('/enrollment');

  return (
    <div className={cx('path-selection-read-more')}>
      <Card className={cx('path-selection-read-more__card')}>
        <CardHeader title="Still can't decide?" />
        <div className={cx('path-selection-read-more__body')}>
          <span className={cx('path-selection-read-more__subtitle')}>
            Let DFIN Assist
          </span>
          <p className={cx('path-selection-read-more__paragraph')}>
            <span className={cx('path-selection-read-more__text')}>
              By choosing this option, you are authorizing DFIN to perform
              administrative functions on your EDGAR Account. This includes:
              <br />
              <ol>
                <li>Managing your DFIN filing delegations.</li>
              </ol>
              This path is ideal for filers who request DFIN to submit filings
              on their behalf or self-filers who sometimes request DFIN to file.
            </span>
          </p>
          <span className={cx('path-selection-read-more__subtitle')}>
            I'll administer my own EDGAR Account
          </span>
          <p className={cx('path-selection-read-more__paragraph')}>
            <span className={cx('path-selection-read-more__text')}>
              By choosing this option, you will be responsible for managing your
              EDGAR Account. These functions include:
              <br />
              <ol>
                <li>Managing your filer agent delegations.</li>
                <li>Managing your users (authorized filers).</li>
                <li>
                  Managing your filer and user tokens (relevant for self-filers
                  only).
                </li>
              </ol>
              This path requires logging into the new EDGAR portal to be ready
              to file under the new EDGAR next requirements.
            </span>
          </p>
        </div>
        <div className={cx('path-selection-read-more__footer')}>
          <Button onClick={onGoBack}>Go back</Button>
        </div>
      </Card>
      <Footer />
    </div>
  );
};

export default PathSelectionReadMore;
